module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="js-inner-container" style="position: relative;">\n    <div class="js-local-community-select-field"></div>\n</div>\n';
}
return __p;
};
